import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection, InspectionPlugin, InspectionPoint, Icons } from '../../../shared/models/index';
import { InstallationObservationPluginService } from './observationsandrecommandations-plugin.service';
import * as _ from 'lodash';

@Component({
    templateUrl: './observationsandrecommendations.component.html',
    standalone: false
})
export class InstallationObservationPluginComponent {
  public observationsAndRecommendations: any;
  public config: any;
  public editRoute = ['installation', 'observation', 'edit'];

  constructor(private cdRef: ChangeDetectorRef, private service: InstallationObservationPluginService) {}

  public getMachineName(index: string) {
    return this.service.getMachineName(index);
  }

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  public initData() {
    this.observationsAndRecommendations = this.config.ObservationsAndRecommendations;
  }
}

PluginComponent.plugins['installationobservation'] = InstallationObservationPluginComponent;
